import React, {Fragment} from 'react'
import { moreFromPocketClick, moreFromPocketScroll } from '../../ctas';
import TrackedLink from '../TrackedLink/Element';
import GaImpressionTrigger from '../GaImpressionTrigger/Element';
import './styles.scss';

const SuggestedArticle = ({article, index}) => {
  const path = `/explore/item/${article.slug}`;
  const ArticleLink = TrackedLink(({...moreFromPocketClick, index}));

  return (
      <GaImpressionTrigger index={index} {...moreFromPocketScroll} >
        <li className="related-article">
          <ArticleLink href={path}>
            <img className="thumbnail" src={article.topImageUrl} />
          </ArticleLink>
          <div className="details">
            <ArticleLink className="publisher-link" href={path}>
              {article.publisher.logoWideBwUrl
                  ? <img className="publisher-logo" src={article.publisher.logoWideBwUrl}/>
                  : <span className="publisher-logo--text">{article.publisher.name}</span>
              }
            </ArticleLink>
            <ArticleLink href={path} className="title">{article.title}</ArticleLink>
          </div>
        </li>
      </GaImpressionTrigger>
  )
};

export default ({sectionTitle = "More Stories from Pocket", articles = []}) => (
    <Fragment>
      <div className="more-from-pocket">
        <h3 className="section-title">{sectionTitle}</h3>
        <ul className="list">
          {articles.map((a, index) => (
              <SuggestedArticle article={a} key={a.slug} index={index}/>
          ))}
        </ul>
      </div>
    </Fragment>
);
